<template lang="pug">
  .component-force-rebook
    button.button(@click="show = !show") Attachment translations
    .row.column(v-if="show" )
        template(v-for="lang in allowedLanguages")
          label {{lang}}
          input(type="text", v-model="translation[lang]", @input="$emit('input', translation)")

</template>

<script>
import ModalReveal from '../../../foundation/ModalReveal'
import ActionButton from '../../ActionButton'
import KeplerFileUpload from "../../../KeplerFileUpload.vue";
import collect from "collect.js";
import {mapState} from "vuex";
import MdiIcon from "../../MdiIcon.vue";

export default {
  name: 'TocAttachmentTranslationReveal',
  components: {MdiIcon, KeplerFileUpload, ActionButton, ModalReveal},
  data() {
    return {
      translation: {},
      selectedLanguage: null,
      show: false
    }
  },
  created() {
    this.allowedLanguages.forEach(lang => {
      if (lang in this.value) {
        this.translation[lang] = this.value[lang]
      } else {
        this.translation[lang] = null
      }
    })
  },
  methods: {},
  computed: {

    allowedLanguages() {
      const systemFields = collect(this.configuration.system.system_fields_configuration.value);
      const defaultLang = this.configuration.application.application_default_language.value
      let config = systemFields.first((i) => i.field === 'allowedLanguages');
      if (config.config === null) {
        return []
      }
      return collect(this.configuration.system.system_fields_configuration.value).first((i) => i.field === 'allowedLanguages').config.split(',').filter((lang) => {
        return lang !== defaultLang
      })
    },
    ...mapState({
      configuration: state => state.configuration,
    }),
  },
  props: ['value']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TocAttachmentTranslationReveal.vue?1707fcb5